/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", async function (e) {
    var label = e.target.closest && e.target.closest(".gb-shipping-protection-button label.switch");
    if (!label) return;
    if (e.target.tagName === "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    const wasChecked = curElem && curElem.classList.contains("checked");

    if (!wasChecked) {
      if (!curElem || !curInputElem || !spinAnim || !checkElem) return;
      if (spinAnim.style.display === "block" || curInputElem.checked) return;
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      try {
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.ok) {
          spinAnim.style.display = "none";

          checkElem.style.display = "block";
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
      }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch((_err) => {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;

      const removeCallback = () => {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.checked = false;
      };

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      if (removeButton && shippingItemIndex && cartItems?.updateQuantity) {
        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: shippingProductId, quantity: 0 }),
        })
          .then(() => fetch(routes.cart_url + "?view=drawer"))
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, removeCallback);
            } else {
              removeCallback();
            }
          })
          .catch(() => {
            removeCallback();
          });
      }
    }
  });

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions: require id when in single-variant mode; skip when form has items[] (bundles / premium kit)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  if (typeof Elixir_ProductFormHasItemsInputs === 'function' && Elixir_ProductFormHasItemsInputs()) return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter (single-product form has no variant id)");
    e.preventDefault();
    if (window.ThemeEditorToast && typeof window.ThemeEditorToast.show === 'function') {
      window.ThemeEditorToast.show('Add to cart failed: missing variant ID on product form.', { type: 'error', duration: 5000 });
    }
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function handleCartQuantityChange(e) {
    var cartItem = e.target.closest(".cart-item");
    if (!cartItem) return;
    var trigger =
      e.target.closest(".quantity__button") ||
      e.target.closest(".quantity__input") ||
      (e.target.matches && e.target.matches(".quantity__input") ? e.target : null);
    if (!trigger) return;
    var quantityInputWrap = trigger.closest(".quantity-input");
    var qtyInput = quantityInputWrap ? quantityInputWrap.querySelector(".quantity__input") : null;
    var variantId = qtyInput ? qtyInput.getAttribute("data-quantity-variant-id") : null;
    var form = trigger.closest("form");
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput && variantId) {
      console.log("Adding missing ID input to cart form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = variantId;
      form.appendChild(newIdInput);
    } else if (idInput && variantId) {
      idInput.value = variantId;
    }
  }
  document.addEventListener("click", handleCartQuantityChange);
  document.addEventListener("change", handleCartQuantityChange);
  document.addEventListener("input", handleCartQuantityChange);

  var checkoutBtn = document.getElementById("CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      var form = document.getElementById("CartDrawer-Form");
      if (!form) return;
      var cartItems = form.querySelectorAll(".cart-item");
      if (cartItems.length === 0) {
        console.log("No items in cart, preventing checkout");
        e.preventDefault();
        return false;
      }
      console.log("Cart checkout with", cartItems.length, "items");
    });
  }

  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

// Kaching showing Price(Compare Price) Text in ATC fix

const KachingApp = () => {
  const isProductPage = document.querySelector('.shopify-section.shop-product-section');
  if (!isProductPage) return;

  let buttonObserver = null;

  const createElement = (tag, cls, content) => {
    const el = document.createElement(tag);
    el.classList.add(...cls.split(' '));
    el.textContent = content;
    return el;
  };

  const updateAddToCartButton = (bundle) => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton || !bundle) return;

    const buttonTextEl = addToCartButton.querySelector('.button-text');
    if (!buttonTextEl) return;

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (bundlePriceEl) {
      const price = bundlePriceEl.textContent.trim();
      const comparePrice = bundleComparePriceEl ? bundleComparePriceEl.textContent.trim() : '';

      // Get the persistent text (e.g., "Buy Now")
      const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

      // Update button text with actual values
      if (comparePrice) {
        buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
      } else {
        buttonTextEl.innerHTML = `${persistentText} - ${price}`;
      }

      // Store current bundle reference for observer
      addToCartButton.dataset.currentBundlePrice = price;
      addToCartButton.dataset.currentBundleComparePrice = comparePrice || '';
    }
  };

  const forceUpdateButton = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    const buttonTextEl = addToCartButton?.querySelector('.button-text');
    
    if (!buttonTextEl) return;

    const price = addToCartButton.dataset.currentBundlePrice;
    const comparePrice = addToCartButton.dataset.currentBundleComparePrice;
    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

    // Check if button shows placeholders
    if (buttonTextEl.textContent.includes('[price]') || buttonTextEl.textContent.includes('[comparePrice]')) {
      if (price) {
        if (comparePrice) {
          buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
        } else {
          buttonTextEl.innerHTML = `${persistentText} - ${price}`;
        }
      }
    }
  };

  const setupButtonObserver = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton) return;

    // Disconnect existing observer if any
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer to watch for button text changes
    buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Use setTimeout to let the other script finish, then override
          setTimeout(forceUpdateButton, 0);
        }
      });
    });

    // Observe the button and its children for any changes
    buttonObserver.observe(addToCartButton, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  };

  const updatePriceBlock = (bundle) => {
    const priceBlock = document.querySelector('.shop-product-price-container');
    if (!priceBlock || !bundle) return;

    const priceEl = priceBlock.querySelector('.shop-product-price-block');
    const comparePriceEl = priceBlock.querySelector('.shop-compare-price');

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (priceEl && bundlePriceEl) priceEl.textContent = bundlePriceEl.textContent;

    if (bundleComparePriceEl) {
      if (comparePriceEl) {
        comparePriceEl.textContent = bundleComparePriceEl.textContent;
      } else {
        priceBlock.appendChild(
          createElement('span', 'shop-compare-price', bundleComparePriceEl.textContent)
        );
      }
    }
  };

  const updateAllPrices = (bundle) => {
    updatePriceBlock(bundle);
    updateAddToCartButton(bundle);
    
    // Force update again after a short delay to override any competing scripts
    setTimeout(() => forceUpdateButton(), 50);
    setTimeout(() => forceUpdateButton(), 200);
  };

  const initApp = (app) => {
    const applyFirstCheckedBundle = () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      if (selectedBundle) {
        updateAllPrices(selectedBundle);
      }
    };

    const initAppFunctions = () => {
      const interval = setInterval(() => {
        const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
        if (selectedBundle) {
          clearInterval(interval);
          updateAllPrices(selectedBundle);
          setupButtonObserver();
        }
      }, 300);
    };

    app.addEventListener('change', () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      updateAllPrices(selectedBundle);
    });

    applyFirstCheckedBundle();
    initAppFunctions();
  };

  const interval = setInterval(() => {
    const app = document.querySelector('kaching-bundle');
    if (app) {
      clearInterval(interval);
      initApp(app);
    }
  }, 300);
};

document.addEventListener('DOMContentLoaded', function () {

  // Candy-2 check
  const disableLyteBitesProductBundle = window.location.href.includes('view=candy-2');
  if (disableLyteBitesProductBundle) {
    setTimeout(function() {
      var form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = '52328071004459';
      }
    }, 600);
  }

  const LyteBitesBundleConfig = {
  variants: {
    1: '49910584082731', // Every 1 month
    2: '49910584148267', // Every 3 months
    3: '49910584181035', // Every 6 months
  },
  sellingPlans: {
    1: '118709616939', // Every 1 month
    2: '118709682475', // Every 3 months
    3: '118709715243', // Every 6 months
  },
  prices: {
    1: 4999,
    2: 8999,
    3: 11999,
  },
  gifts: {
    1: [
      {
        id: '53368863260971',
        label: 'Anti-Aging Sleep Strategies Ebook',
        qty: '1x included',
        compare: '$20.00',
        image: 'https://lytebites.com/cdn/shop/files/Untitled_design_16.png',
      },
    ],
    2: [
      {
        id: '53368863260971',
        label: 'Anti-Aging Sleep Strategies Ebook',
        qty: '1x included',
        compare: '$20.00',
        image: 'https://lytebites.com/cdn/shop/files/Untitled_design_16.png',
      },
      {
        id: '53313405518123',
        label: 'Sleep Strips',
        qty: '1x included',
        compare: '$36.99',
        image: 'https://cdn.shopify.com/s/files/1/0871/7582/3659/files/1774322254976-generated-label-image-0.jpg?v=1775658896',
      },
    ],
    3: [
      {
        id: '53368863260971',
        label: 'Anti-Aging Sleep Strategies Ebook',
        qty: '1x included',
        compare: '$20.00',
        image: 'https://lytebites.com/cdn/shop/files/Untitled_design_16.png',
      },
      {
        id: '53313405518123',
        label: 'Sleep Strips',
        qty: '1x included',
        compare: '$36.99',
        image: 'https://cdn.shopify.com/s/files/1/0871/7582/3659/files/1774322254976-generated-label-image-0.jpg?v=1775658896',
      },
      {
        id: '53313406468395',
        label: 'Anti-Aging Vitamin C Serum',
        qty: '1x included',
        compare: '$23.99',
        image: 'https://cdn.shopify.com/s/files/1/0871/7582/3659/files/1774444413219-generated-label-image-0.jpg?v=1775658882',
      },
    ],
  },
  displayGifts: {
    1: [
      {
        label: 'Anti-Aging Sleep Strategies Ebook',
        qty: '1x included',
        compare: '$20.00',
        image: 'https://lytebites.com/cdn/shop/files/Untitled_design_16.png',
      },
    ],
    2: [
      {
        label: 'Anti-Aging Sleep Strategies Ebook',
        qty: '1x included',
        compare: '$20.00',
        image: 'https://lytebites.com/cdn/shop/files/Untitled_design_16.png',
      },
      {
        label: 'Sleep Strips',
        qty: '1x included',
        compare: '$36.99',
        image: 'https://cdn.shopify.com/s/files/1/0871/7582/3659/files/1774322254976-generated-label-image-0.jpg?v=1775658896',
      },
    ],
    3: [
      {
        label: 'Anti-Aging Sleep Strategies Ebook',
        qty: '1x included',
        compare: '$20.00',
        image: 'https://lytebites.com/cdn/shop/files/Untitled_design_16.png',
      },
      {
        label: 'Sleep Strips',
        qty: '1x included',
        compare: '$36.99',
        image: 'https://cdn.shopify.com/s/files/1/0871/7582/3659/files/1774322254976-generated-label-image-0.jpg?v=1775658896',
      },
      {
        label: 'Vitamin C Serum',
        qty: '1x included',
        compare: '$23.99',
        image: 'https://cdn.shopify.com/s/files/1/0871/7582/3659/files/1774444413219-generated-label-image-0.jpg?v=1775658882',
      },
    ],
  },
  displayValues: {
    1: '$20',
    2: '$47',
    3: '$81',
  },
};
  const legacyUntaggedGiftVariantIds = new Set(['53313405518123', '53313406468395']);
  const _origFetch = window.fetch.bind(window);
  const BUNDLE_PARENT_ROLE = 'parent';
  const BUNDLE_GIFT_ROLE = 'gift';
  function getSelectedBundleCard() {
    return (
      document.querySelector('.mqb-card[data-selected="true"]') ||
      document.querySelector('.quantity-bundle-card[data-selected="true"]')
    );
  }

  function hasBundleSelector() {
    if (disableLyteBitesProductBundle) return false;
    return !!document.querySelector('.mqb-card, .quantity-bundle-card');
  }

  function getSelectedBundleTier() {
    const selected = getSelectedBundleCard();
    if (!selected) return 1;
    const index = parseInt(selected.getAttribute('data-index'), 10);
    if (!isNaN(index) && index > 0) return index;

    const qty = parseInt(selected.getAttribute('data-quantity') || '1', 10);
    if (qty === 6) return 3;
    if (qty === 3 || qty === 2) return 2;
    return 1;
  }

  function getSelectedBundleQty() {
    const selected = getSelectedBundleCard();
    if (!selected) return 1;
    return parseInt(selected.getAttribute('data-quantity') || '1', 10);
  }

  function getSelectedBundlePriceCents() {
    const selected = getSelectedBundleCard();
    if (!selected) return 0;
    return parseInt(selected.getAttribute('data-price') || '0', 10) || 0;
  }

  function isSubscribeSelected() {
    return !!document.querySelector(
      '.subscribe-toggle-switch input[type="checkbox"]:checked, .subscribe-toggle-dynamic:checked, input[name="selling_plan"][value]:not([value=""])'
    );
  }

  function swapVariant(variantId) {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form || !variantId) return;
    let idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
  }

  function getBundleVariantId(qty) {
    return LyteBitesBundleConfig.variants[qty] || '';
  }

  function getBundleSellingPlan(qty) {
    return LyteBitesBundleConfig.sellingPlans[qty] || LyteBitesBundleConfig.sellingPlans[1] || '';
  }

  function getBundleGifts(qty) {
    return (LyteBitesBundleConfig.gifts[qty] || []).filter(function(gift) {
      return gift && gift.id;
    });
  }

  function getCartItemSellingPlanId(item) {
    const allocation = item && item.selling_plan_allocation;
    const sellingPlan = allocation && allocation.selling_plan;
    return sellingPlan && sellingPlan.id ? String(sellingPlan.id) : '';
  }

  function isLyteBitesBundleParent(item) {
    const role = getLineProperty(item, '_bundle_role');
    if (role) return role === BUNDLE_PARENT_ROLE;
    return getLineProperty(item, '_bundle_type') === 'lytebites_subscription';
  }

  function getCartBundleTier(item) {
    const configuredTier = parseInt(getLineProperty(item, '_bundle_tier'), 10);
    if (configuredTier > 0) return configuredTier;

    const variantId = String((item && (item.variant_id || item.id)) || '');
    const matchedTier = Object.keys(LyteBitesBundleConfig.variants).find(function(tier) {
      return String(LyteBitesBundleConfig.variants[tier]) === variantId;
    });
    return parseInt(matchedTier, 10) || 1;
  }

  function getBundleIdentity(variantId, tier, sellingPlanId) {
    return [
      'lb',
      String(variantId || ''),
      String(tier || 1),
      String(sellingPlanId || 'one-time'),
    ].join('-');
  }

  function createBundleInstanceId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'lb-' + window.crypto.randomUUID();
    }

    return [
      'lb',
      Date.now().toString(36),
      Math.random().toString(36).slice(2, 12),
    ].join('-');
  }

  function getCartBundleIdentity(item) {
    const configuredKey = getLineProperty(item, '_bundle_id') || getLineProperty(item, '_bundle_key');
    if (configuredKey) return configuredKey;
    if (item && item.key) return 'lb-legacy-' + String(item.key);

    return getBundleIdentity(
      item && (item.variant_id || item.id),
      getCartBundleTier(item),
      getCartItemSellingPlanId(item)
    );
  }

  let managedBundleGiftVariantIdsCache = null;

  function getManagedBundleGiftVariantIds() {
    if (managedBundleGiftVariantIdsCache) return managedBundleGiftVariantIdsCache;
    const ids = new Set();
    Object.keys(LyteBitesBundleConfig.gifts).forEach(function(tier) {
      getBundleGifts(tier).forEach(function(gift) {
        ids.add(String(gift.id));
      });
    });
    managedBundleGiftVariantIdsCache = ids;
    return managedBundleGiftVariantIdsCache;
  }

  function getProductAddForm() {
    if (typeof Elixir_GetProductForm === 'function') {
      const form = Elixir_GetProductForm();
      if (form) return form;
    }
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getCartDrawerSections(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function(section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function setBundleSubmitLoading(form, isLoading) {
    const submitButton =
      form.querySelector('.shop-add-to-cart-button') ||
      form.querySelector('[type="submit"]');
    if (!submitButton) return;

    const spinner = submitButton.querySelector('.loading__spinner');
    if (isLoading) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function showBundleAddError(form, message) {
    const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    const errorMessage = form.querySelector('.product-form__error-message');
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = message || 'Unable to add bundle to cart.';
      errorWrapper.removeAttribute('hidden');
    } else {
      console.error('[LyteBites bundle] Add to cart failed:', message);
    }
  }

  function getLineProperty(item, key) {
    const properties = item && item.properties;
    if (!properties) return '';

    if (Array.isArray(properties)) {
      const found = properties.find(function(prop) {
        return prop && (prop[0] === key || prop.name === key);
      });
      if (!found) return '';
      return String(found[1] != null ? found[1] : found.value || '');
    }

    return properties[key] != null ? String(properties[key]) : '';
  }

  function getBundleCartJsonUrl() {
    const cartUrl = (window.routes && routes.cart_url) || '/cart';
    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function getBundleCartUpdateUrl() {
    const updateUrl = (window.routes && routes.cart_update_url) || '/cart/update';
    return updateUrl.indexOf('.js') > -1 ? updateUrl : updateUrl.replace(/\/$/, '') + '.js';
  }

  function getBundleSectionRequest() {
    return {
      sections: getCartDrawerSections(document.querySelector('cart-drawer')),
      sections_url: window.location.pathname,
    };
  }

  function readBundleCart(attempt) {
    const retryAttempt = Math.max(0, parseInt(attempt, 10) || 0);
    const maxAttempts = 3;

    return _origFetch(getBundleCartJsonUrl(), {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(function(response) {
        if (!response.ok) {
          const error = new Error(response.statusText || 'Unable to read the cart.');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .catch(function(error) {
        if (retryAttempt >= maxAttempts - 1) throw error;

        return new Promise(function(resolve) {
          setTimeout(resolve, 200 * (retryAttempt + 1));
        }).then(function() {
          return readBundleCart(retryAttempt + 1);
        });
      });
  }

  function parseCartAddResponse(response) {
    return response.text().then(function(text) {
      let data = {};
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          if (!response.ok) {
            throw new Error(text);
          }
          throw error;
        }
      }

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || response.statusText || 'Unable to add bundle to cart.');
      }

      return data;
    });
  }

  function getBundleCartAddUrl() {
    const addUrl = (window.routes && routes.cart_add_url) || '/cart/add';
    return addUrl.indexOf('.js') > -1 ? addUrl : addUrl.replace(/\/$/, '') + '.js';
  }

  function requestBundleCartAdd(items) {
    if (!Array.isArray(items) || items.length === 0) return Promise.resolve(null);

    const sectionRequest = getBundleSectionRequest();

    return _origFetch(getBundleCartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: items,
        sections: sectionRequest.sections,
        sections_url: sectionRequest.sections_url,
      }),
    }).then(parseCartAddResponse);
  }

  function requestBundleCartUpdate(updates) {
    if (!updates || Object.keys(updates).length === 0) return Promise.resolve(null);

    const sectionRequest = getBundleSectionRequest();

    return _origFetch(getBundleCartUpdateUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: updates,
        sections: sectionRequest.sections,
        sections_url: sectionRequest.sections_url,
      }),
    }).then(parseCartAddResponse);
  }

  function getDesiredBundleGiftGroups(cart) {
    const groups = {};

    (cart && cart.items || []).forEach(function(item) {
      if (!isLyteBitesBundleParent(item) || !getCartItemSellingPlanId(item)) return;

      const tier = getCartBundleTier(item);
      const paidQuantity = Math.max(0, parseInt(item.quantity, 10) || 0);
      const eligibleBundleCount = Math.floor(paidQuantity / tier);
      if (eligibleBundleCount < 1) return;

      const bundleIdentity = getCartBundleIdentity(item);
      getBundleGifts(tier).forEach(function(gift) {
        const groupKey = bundleIdentity + '::' + String(gift.id);
        if (!groups[groupKey]) {
          groups[groupKey] = {
            key: groupKey,
            bundleIdentity: bundleIdentity,
            tier: tier,
            gift: gift,
            quantity: 0,
          };
        }
        groups[groupKey].quantity += eligibleBundleCount;
      });
    });

    return groups;
  }

  function isManagedBundleGift(item) {
    const variantId = String((item && (item.variant_id || item.id)) || '');
    const properties = item && item.properties || {};
    const managedVariantIds = getManagedBundleGiftVariantIds();

    if (properties._bundle_role === BUNDLE_GIFT_ROLE) return true;
    if (properties._gift_parent_key || properties._gift_type === 'bundle_subscription_gift') return true;
    if (properties._free_gift === 'true' && managedVariantIds.has(variantId)) return true;

    return (
      Number(item && item.final_line_price) === 0 &&
      (managedVariantIds.has(variantId) || legacyUntaggedGiftVariantIds.has(variantId))
    );
  }

  function findGiftGroupForItem(item, groups) {
    const variantId = String((item && (item.variant_id || item.id)) || '');
    const properties = item && item.properties || {};

    const configuredBundleId = properties._bundle_id || properties._gift_parent_key;
    if (configuredBundleId) {
      return groups[String(configuredBundleId) + '::' + variantId] || null;
    }

    if (properties._gift_parent_bundle) {
      const tierMatches = Object.keys(groups).map(function(key) { return groups[key]; }).filter(function(group) {
        return (
          String(group.tier) === String(properties._gift_parent_bundle) &&
          String(group.gift.id) === variantId
        );
      });
      return tierMatches.length === 1 ? tierMatches[0] : null;
    }

    return null;
  }

  function buildCanonicalGiftItem(group) {
    return {
      id: String(group.gift.id),
      quantity: group.quantity,
      properties: {
        _free_gift: 'true',
        _bundle_id: group.bundleIdentity,
        _bundle_role: BUNDLE_GIFT_ROLE,
        _gift_type: 'bundle_subscription_gift',
        _gift_parent_key: group.bundleIdentity,
        _gift_parent_bundle: String(group.tier),
        _gift_label: group.gift.label || 'Free Gift',
      },
    };
  }

  function getBundleIntegrityPlan(cart) {
    const desiredGroups = getDesiredBundleGiftGroups(cart);
    const managedGiftItems = (cart && cart.items || []).filter(isManagedBundleGift);
    const updates = {};
    const missingItems = [];
    const retainedKeys = new Set();
    const giftItemsByGroup = {};

    managedGiftItems.forEach(function(item) {
      const matchedGroup = findGiftGroupForItem(item, desiredGroups);
      if (!matchedGroup) return;
      if (!giftItemsByGroup[matchedGroup.key]) giftItemsByGroup[matchedGroup.key] = [];
      giftItemsByGroup[matchedGroup.key].push(item);
    });

    Object.keys(desiredGroups).forEach(function(groupKey) {
      const group = desiredGroups[groupKey];
      const matchingItems = giftItemsByGroup[group.key] || [];
      const primary = matchingItems.find(function(item) {
        return (
          getLineProperty(item, '_bundle_id') === group.bundleIdentity &&
          getLineProperty(item, '_bundle_role') === BUNDLE_GIFT_ROLE
        );
      });

      if (!primary) {
        missingItems.push(buildCanonicalGiftItem(group));
        matchingItems.forEach(function(item) { updates[item.key] = 0; });
        return;
      }

      retainedKeys.add(primary.key);
      if (Number(primary.quantity) !== Number(group.quantity)) {
        updates[primary.key] = group.quantity;
      }

      matchingItems.forEach(function(item) {
        if (item.key !== primary.key) updates[item.key] = 0;
      });
    });

    managedGiftItems.forEach(function(item) {
      if (!retainedKeys.has(item.key) && updates[item.key] == null) updates[item.key] = 0;
    });

    return {
      updates: updates,
      missingItems: missingItems,
      valid: Object.keys(updates).length === 0 && missingItems.length === 0,
    };
  }

  function attachBundleSections(cart, source) {
    if (cart && !cart.sections && source && source.sections) cart.sections = source.sections;
    return cart;
  }

  function validateBundleCartIntegrity(cart, preferredResponse) {
    let currentCart = attachBundleSections(cart, preferredResponse);
    let repaired = false;
    let plan = getBundleIntegrityPlan(currentCart);

    const applyInitialUpdates = Object.keys(plan.updates).length > 0
      ? requestBundleCartUpdate(plan.updates).then(function(updatedCart) {
          repaired = true;
          currentCart = updatedCart;
          plan = getBundleIntegrityPlan(currentCart);
        })
      : Promise.resolve();

    return applyInitialUpdates
      .then(function() {
        if (plan.missingItems.length === 0) return null;
        repaired = true;
        return requestBundleCartAdd(plan.missingItems).then(function(addResponse) {
          return readBundleCart().then(function(freshCart) {
            currentCart = attachBundleSections(freshCart, addResponse);
            plan = getBundleIntegrityPlan(currentCart);
          });
        });
      })
      .then(function() {
        if (Object.keys(plan.updates).length === 0) return null;
        repaired = true;
        return requestBundleCartUpdate(plan.updates).then(function(updatedCart) {
          currentCart = updatedCart;
          plan = getBundleIntegrityPlan(currentCart);
        });
      })
      .then(function() {
        if (!plan.valid) {
          throw new Error('The cart could not be validated. Please refresh and try again.');
        }
        currentCart.__lbIntegrityRepaired = repaired;
        return currentCart;
      });
  }

  function fetchAuthoritativeCartSections() {
    const sectionIds = getCartDrawerSections(document.querySelector('cart-drawer'));
    const separator = window.location.pathname.indexOf('?') > -1 ? '&' : '?';
    const sectionUrl = window.location.pathname + separator + 'sections=' + sectionIds.join(',');

    return _origFetch(sectionUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function(response) {
      if (!response.ok) throw new Error(response.statusText || 'Unable to refresh the cart drawer.');
      return response.json();
    });
  }

  function renderAuthoritativeBundleCart(cart, openDrawer) {
    const cartPath = new URL((window.routes && routes.cart_url) || '/cart', window.location.origin).pathname;
    if (window.location.pathname === cartPath && document.querySelector('cart-items')) {
      window.location.reload();
      return Promise.resolve(cart);
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return Promise.resolve(cart);

    const sectionsPromise = cart && cart.sections && cart.sections['cart-drawer']
      ? Promise.resolve(cart.sections)
      : fetchAuthoritativeCartSections();

    return sectionsPromise.then(function(sections) {
      return Promise.resolve(cartDrawer.renderContents({
        id: null,
        item_count: Number(cart && cart.item_count) || 0,
        sections: sections,
      }, { open: openDrawer !== false })).then(function() {
        return cart;
      });
    });
  }

  let bundleMutationQueue = Promise.resolve();
  let pendingBundleSubmissions = 0;

  function enqueueBundleMutation(task, form) {
    pendingBundleSubmissions += 1;
    if (form) setBundleSubmitLoading(form, true);

    const runMutation = function() {
      return Promise.resolve().then(task);
    };
    const queuedMutation = bundleMutationQueue.then(runMutation, runMutation);

    bundleMutationQueue = queuedMutation.catch(function() {});
    return queuedMutation.finally(function() {
      pendingBundleSubmissions = Math.max(0, pendingBundleSubmissions - 1);
      if (form && pendingBundleSubmissions === 0) setBundleSubmitLoading(form, false);
    });
  }

  function showCartBundleQuantityError(line, message) {
    const lineError =
      document.querySelector('#CartDrawer-LineItemError-' + line + ' .cart-item__error-text') ||
      document.querySelector('#Line-item-error-' + line + ' .cart-item__error-text');
    const cartError = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    const errorMessage = message || 'Unable to update the bottle quantity. Please try again.';

    if (lineError) {
      lineError.textContent = errorMessage;
      if (lineError.parentElement) lineError.parentElement.style.display = 'block';
    } else if (cartError) {
      cartError.textContent = errorMessage;
    }
  }

  function performCartBundleQuantityUpdate(options) {
    const line = Math.max(1, parseInt(options && options.line, 10) || 1);
    const quantity = Math.max(0, parseInt(options && options.quantity, 10) || 0);
    const requestedLineKey = String(options && options.lineItemKey || '');
    const requestedBundleId = String(options && options.bundleId || '');
    const requestedTier = Math.max(0, parseInt(options && options.bundleTier, 10) || 0);
    const cartDrawer = document.querySelector('cart-drawer');
    const shouldKeepDrawerOpen = !!(cartDrawer && cartDrawer.classList.contains('active'));

    return readBundleCart()
      .then(function(cart) {
        let parentItem = requestedLineKey
          ? (cart.items || []).find(function(item) { return item.key === requestedLineKey; })
          : null;

        if (!parentItem && requestedBundleId) {
          parentItem = (cart.items || []).find(function(item) {
            return isLyteBitesBundleParent(item) && getCartBundleIdentity(item) === requestedBundleId;
          });
        }
        if (!parentItem && !requestedLineKey && !requestedBundleId) {
          parentItem = (cart.items || [])[line - 1];
        }

        if (!parentItem || !isLyteBitesBundleParent(parentItem)) {
          throw new Error('This bundle is no longer available in the cart.');
        }

        const tier = getCartBundleTier(parentItem);
        const currentQuantity = Math.max(0, parseInt(parentItem.quantity, 10) || 0);

        if (requestedTier && requestedTier !== tier) {
          throw new Error('This bundle changed while the cart was updating. Please try again.');
        }

        if (quantity > 0 && (quantity < tier || quantity % tier !== 0)) {
          throw new Error('Bundle quantity must be changed in increments of ' + tier + '.');
        }

        if (currentQuantity === quantity) return cart;

        const updates = {};
        updates[parentItem.key] = quantity;
        const projectedCart = Object.assign({}, cart, {
          items: (cart.items || []).map(function(item) {
            if (item.key !== parentItem.key) return item;
            return Object.assign({}, item, { quantity: quantity });
          }),
        });
        const projectedPlan = getBundleIntegrityPlan(projectedCart);
        Object.keys(projectedPlan.updates).forEach(function(key) {
          updates[key] = projectedPlan.updates[key];
        });

        return requestBundleCartUpdate(updates);
      })
      .then(function(updatedCart) {
        return validateBundleCartIntegrity(updatedCart);
      })
      .then(function(finalCart) {
        return renderAuthoritativeBundleCart(finalCart, shouldKeepDrawerOpen).then(function() {
          document.dispatchEvent(
            new CustomEvent('lytebites:bundle-cart-updated', {
              detail: { quantity: quantity, cart: finalCart },
            })
          );
          return true;
        });
      })
      .catch(function(error) {
        console.error('[LyteBites bundle] Cart quantity update failed:', error);
        showCartBundleQuantityError(line, error && error.message);
        throw error;
      });
  }

  window.LyteBitesUpdateCartBundleQuantity = function(options) {
    return enqueueBundleMutation(function() {
      return performCartBundleQuantityUpdate(options);
    });
  };

  window.LyteBitesValidateBundleCart = function() {
    return enqueueBundleMutation(function() {
      return readBundleCart().then(function(cart) {
        return validateBundleCartIntegrity(cart);
      });
    });
  };

  let checkoutValidationPending = false;

  function showBundleCheckoutError(message) {
    const errorElement =
      document.getElementById('CartDrawer-CartErrors') ||
      document.getElementById('cart-errors');
    if (errorElement) errorElement.textContent = message;
  }

  function cartHasCheckoutItem(cart) {
    return (cart && cart.items || []).some(function(item) {
      return Number(item.quantity) > 0 && !isManagedBundleGift(item);
    });
  }

  function queueValidatedCheckout(trigger) {
    if (checkoutValidationPending) return;
    checkoutValidationPending = true;
    if (trigger) {
      trigger.setAttribute('aria-disabled', 'true');
      trigger.classList.add('loading');
    }

    enqueueBundleMutation(function() {
      return readBundleCart()
        .then(function(cart) {
          return validateBundleCartIntegrity(cart);
        })
        .then(function(validCart) {
          if (!cartHasCheckoutItem(validCart)) {
            return renderAuthoritativeBundleCart(validCart, true).then(function() {
              throw new Error('Your cart has no qualifying paid items. Free gifts were removed.');
            });
          }

          window.location.assign(
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'checkout'
          );
        });
    }).catch(function(error) {
      console.error('[LyteBites bundle] Checkout validation failed:', error);
      showBundleCheckoutError(error && error.message ? error.message : 'Unable to validate the cart.');
      checkoutValidationPending = false;
      if (trigger && trigger.isConnected) {
        trigger.removeAttribute('aria-disabled');
        trigger.classList.remove('loading');
      }
    });
  }

  function getSelectedBundleAddSelection() {
    const tier = getSelectedBundleTier();
    const variantId = getBundleVariantId(tier);
    const subscribed = isSubscribeSelected();
    const sellingPlanId = subscribed ? getBundleSellingPlan(tier) : '';

    if (!tier || !variantId || (subscribed && !sellingPlanId)) return null;

    return {
      tier: tier,
      variantId: String(variantId),
      subscribed: subscribed,
      sellingPlanId: String(sellingPlanId || ''),
      selectedPriceCents: getSelectedBundlePriceCents(),
      bundleId: createBundleInstanceId(),
    };
  }

  function buildBundleParentProperties(selection) {
    const properties = {
      _bundle_type: 'lytebites_subscription',
      _bundle_tier: String(selection.tier),
      _bundle_quantity: String(selection.tier),
      _bundle_key: selection.bundleId,
      _bundle_id: selection.bundleId,
      _bundle_role: BUNDLE_PARENT_ROLE,
      _bundle_mode: selection.subscribed ? 'subscription' : 'one_time',
      _quantity_option: String(selection.tier),
    };

    if (selection.selectedPriceCents > 0) {
      properties._custom_total_price = (selection.selectedPriceCents / 100).toFixed(2);
    }

    return properties;
  }

  function performBundleAdd(selection) {
    let addResponse = null;
    return Promise.resolve()
      .then(function() {
        const parentProperties = buildBundleParentProperties(selection);
        const bundleIdentity = selection.bundleId;
        const paidItem = {
          id: selection.variantId,
          quantity: selection.tier,
          properties: parentProperties,
        };

        if (selection.subscribed) paidItem.selling_plan = selection.sellingPlanId;
        const items = [paidItem];
        if (selection.subscribed) {
          getBundleGifts(selection.tier).forEach(function(gift) {
            items.push({
              id: String(gift.id),
              quantity: 1,
              properties: {
                _free_gift: 'true',
                _bundle_id: bundleIdentity,
                _bundle_role: BUNDLE_GIFT_ROLE,
                _gift_type: 'bundle_subscription_gift',
                _gift_parent_key: bundleIdentity,
                _gift_parent_bundle: String(selection.tier),
                _gift_label: gift.label || 'Free Gift',
              },
            });
          });
        }

        return requestBundleCartAdd(items).then(function(response) {
          addResponse = response;
          return response;
        });
      })
      .then(function() {
        return readBundleCart();
      })
      .then(function(cart) {
        return validateBundleCartIntegrity(cart, addResponse);
      })
      .then(function(finalCart) {
        return renderAuthoritativeBundleCart(finalCart, true).then(function() {
          document.dispatchEvent(new CustomEvent('lytebites:bundle-cart-updated', {
            detail: { cart: finalCart, source: 'add' },
          }));
          return finalCart;
        });
      });
  }

  function queueSelectedBundleAdd(form, selection) {
    return enqueueBundleMutation(function() {
      return performBundleAdd(selection);
    }, form).catch(function(error) {
      console.error('[LyteBites bundle] Add to cart error:', error);
      showBundleAddError(form, error && error.message ? error.message : 'Unable to add bundle to cart.');
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function injectGiftBoxStyles() {
    if (document.getElementById('lb-dynamic-gifts-style')) return;
    const style = document.createElement('style');
    style.id = 'lb-dynamic-gifts-style';
    style.textContent = `
      #lb-dynamic-gifts { width: 100%; }
      .lb-tier-gifts-wrapper { margin: 8px 0 12px; font-family: inherit; }
      .subscribe-save-wrapper .subscribe-benefits-wrapper .free-gift-container,
      .subscribe-save-wrapper .subscribe-benefits-wrapper .bonus-list { display: none !important; }
      .lb-gifts-box { border: 1.5px solid #e8e8e8; border-radius: 10px; padding: 12px 14px; background: #fff; transition: border-color 0.3s ease, background-color 0.3s ease; }
      .lb-gifts-box.lb-active { border-color: #e8601c; background: #fff9f7; }
      .lb-gifts-header { display: flex; justify-content: space-between; align-items: center; gap: 10px; margin-bottom: 10px; }
      .lb-gifts-title { font-size: 13px; font-weight: 600; color: #1a1a1a; display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
      .lb-gifts-title-icon { width: 20px; height: 20px; object-fit: contain; }
      .lb-gifts-badge { font-size: 11px; background: #fff3ee; color: #e8601c; border: 1px solid #ffd0b8; border-radius: 20px; padding: 2px 10px; font-weight: 700; white-space: nowrap; }
      .lb-gift-row { display: flex; justify-content: space-between; align-items: center; gap: 10px; padding: 7px 0; border-bottom: 1px solid #f0f0f0; }
      .lb-gift-row:last-child { border-bottom: none; padding-bottom: 0; }
      .lb-gift-left { display: flex; align-items: center; gap: 8px; min-width: 0; }
      .lb-gift-icon { width: 32px; height: 32px; border-radius: 6px; background: #f8f8f8; border: 1px solid #e8e8e8; display: flex; align-items: center; justify-content: center; overflow: hidden; flex-shrink: 0; }
      .lb-gift-icon img { width: 100%; height: 100%; object-fit: cover; display: block; }
      .lb-gift-name { font-size: 12px; color: #1a1a1a; font-weight: 500; line-height: 1.3; }
      .lb-gift-qty { font-size: 11px; color: #888; }
      .lb-gift-price-col { text-align: right; flex-shrink: 0; }
      .lb-gift-free { font-size: 12px; font-weight: 700; color: #1a9e5e; }
      .lb-gift-compare { font-size: 11px; color: #999; text-decoration: line-through; }
      .lb-upgrade-msg { font-size: 12px; color: #666; text-align: center; padding: 8px 0; line-height: 1.5; }
      .lb-upgrade-msg strong { color: #e8601c; }
      .lb-value-badge { display: inline-flex; align-items: center; background: #e8601c; color: #fff; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 4px; margin-left: 4px; }
    `;
    document.head.appendChild(style);
  }

  function ensureGiftBox() {
    let wrapper = document.getElementById('lb-dynamic-gifts');
    if (wrapper) return wrapper;

    const subscribeBlock = document.querySelector('.subscribe-save-wrapper, .subscribe-save-dynamic-outer');
    const addToCartBlock = document.querySelector('.shop-add-to-cart-wrapper');
    const anchor = subscribeBlock || addToCartBlock;
    if (!anchor || !anchor.parentNode) return null;

    wrapper = document.createElement('div');
    wrapper.className = 'lb-tier-gifts-wrapper';
    wrapper.id = 'lb-dynamic-gifts';
    wrapper.innerHTML = '<div class="lb-gifts-box" id="lb-gifts-box"><div class="lb-upgrade-msg">Select a subscription plan above to see your free gifts.</div></div>';

    if (subscribeBlock && subscribeBlock.nextSibling) {
      subscribeBlock.parentNode.insertBefore(wrapper, subscribeBlock.nextSibling);
    } else if (subscribeBlock) {
      subscribeBlock.parentNode.appendChild(wrapper);
    } else {
      addToCartBlock.parentNode.insertBefore(wrapper, addToCartBlock);
    }

    return wrapper;
  }

  function updateGiftBox() {
    injectGiftBoxStyles();
    const wrapper = ensureGiftBox();
    const box = wrapper ? wrapper.querySelector('#lb-gifts-box') : null;
    if (!box) return;

    const tier = getSelectedBundleTier();
    const subscribed = isSubscribeSelected();
    const gifts = LyteBitesBundleConfig.displayGifts[tier] || [];

    if (!subscribed) {
      box.className = 'lb-gifts-box';
      box.innerHTML = '<div class="lb-upgrade-msg">Subscribe above to unlock free gifts!</div>';
      return;
    }

    if (gifts.length === 0) {
      box.className = 'lb-gifts-box';
      box.innerHTML = '<div class="lb-upgrade-msg">No free gifts on the Starter plan.<br>Upgrade to <strong>Popular</strong> or <strong>Best Value</strong> to unlock free gifts!</div>';
      return;
    }

    const value = LyteBitesBundleConfig.displayValues[tier] || '';
    const header = [
      '<div class="lb-gifts-header">',
      '<div class="lb-gifts-title">',
      '<img src="https://lytebites.com/cdn/shop/files/Untitled_design_18.png" alt="Free Gift" class="lb-gifts-title-icon">',
      'Free Gifts Included',
      value ? '<span class="lb-value-badge">' + escapeHtml(value) + ' VALUE</span>' : '',
      '</div>',
      '<div class="lb-gifts-badge">' + gifts.length + ' FREE GIFT' + (gifts.length > 1 ? 'S' : '') + '</div>',
      '</div>',
    ].join('');

    const rows = gifts.map(function(gift) {
      return [
        '<div class="lb-gift-row">',
        '<div class="lb-gift-left">',
        '<div class="lb-gift-icon"><img src="' + escapeHtml(gift.image) + '" alt="' + escapeHtml(gift.label) + '"></div>',
        '<div class="lb-gift-info">',
        '<div class="lb-gift-name">' + escapeHtml(gift.label) + '</div>',
        '<div class="lb-gift-qty">' + escapeHtml(gift.qty) + '</div>',
        '</div></div>',
        '<div class="lb-gift-price-col">',
        '<div class="lb-gift-free">FREE</div>',
        '<div class="lb-gift-compare">' + escapeHtml(gift.compare) + '</div>',
        '</div></div>',
      ].join('');
    }).join('');

    box.className = 'lb-gifts-box lb-active';
    box.innerHTML = header + rows;
  }

  function scheduleGiftBoxUpdate(delay) {
    setTimeout(updateGiftBox, delay || 100);
  }

  // Bundle card click
  document.body.addEventListener('click', function (e) {
    const bundleCard = e.target.closest('.mqb-card, .quantity-bundle-card');
    if (bundleCard) {
      setTimeout(function() {
        if (!hasBundleSelector()) return;
        const tier = getSelectedBundleTier();
        const variantId = getBundleVariantId(tier);
        if (variantId) swapVariant(variantId);
        updateGiftBox();
      }, 100);
    }
    const btn = e.target.closest('.shop-add-to-cart-button');
    if (!btn) return;
    if (!hasBundleSelector()) return;
    const tier = getSelectedBundleTier();
    const variantId = getBundleVariantId(tier);
    if (variantId) swapVariant(variantId);
  });

  // Subscribe toggle
  document.body.addEventListener('change', function(e) {
    const toggle = e.target.closest('.subscribe-toggle-switch input[type="checkbox"]');
    if (!toggle) return;
    setTimeout(function() {
      if (!hasBundleSelector()) return;
      const tier = getSelectedBundleTier();
      const variantId = getBundleVariantId(tier);
      if (variantId) swapVariant(variantId);
      updateGiftBox();
    }, 150);
  });

  // Page load
  setTimeout(function() {
    if (!hasBundleSelector()) return;
    const tier = getSelectedBundleTier();
    const variantId = getBundleVariantId(tier);
    if (variantId) swapVariant(variantId);
    updateGiftBox();
  }, 500);

  document.addEventListener('quantity_break:changed', function() { scheduleGiftBoxUpdate(100); });
  document.addEventListener('quantity:changed', function() { scheduleGiftBoxUpdate(100); });
  document.addEventListener('subscriptionContext:updated', function() { scheduleGiftBoxUpdate(150); });

  function handleBundleAddEvent(e, form) {
    if (!hasBundleSelector()) return false;
    const selection = getSelectedBundleAddSelection();
    if (!selection) return false;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    queueSelectedBundleAdd(form, selection);
    return true;
  }

  document.addEventListener('click', function(e) {
    const button = e.target.closest('.shop-add-to-cart-button, button[type="submit"][name="add"]');
    if (!button) return;
    const form = getProductAddForm();
    if (!form || (button.form && button.form !== form)) return;
    handleBundleAddEvent(e, form);
  }, true);

  document.addEventListener('submit', function(e) {
    const form = getProductAddForm();
    if (!form || e.target !== form) return;
    handleBundleAddEvent(e, form);
  }, true);

  document.addEventListener('click', function(e) {
    const checkoutTrigger = e.target.closest(
      '#CartDrawer-Checkout, #checkout, .cart__checkout-button, a[href*="/checkout"]'
    );
    if (!checkoutTrigger) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    queueValidatedCheckout(checkoutTrigger);
  }, true);

  document.addEventListener('submit', function(e) {
    const submitter = e.submitter;
    const isCheckoutSubmit = !!(
      submitter &&
      (submitter.name === 'checkout' || submitter.id === 'checkout' || submitter.id === 'CartDrawer-Checkout')
    );
    if (!isCheckoutSubmit) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    queueValidatedCheckout(submitter);
  }, true);

  if (document.querySelector('cart-drawer[data-lb-managed-cart="true"]')) {
    enqueueBundleMutation(function() {
      return readBundleCart()
        .then(function(cart) {
          return validateBundleCartIntegrity(cart);
        })
        .then(function(validCart) {
          if (!validCart.__lbIntegrityRepaired) return validCart;
          return renderAuthoritativeBundleCart(validCart, false);
        });
    }).catch(function(error) {
      console.error('[LyteBites bundle] Initial cart validation failed:', error);
    });
  }

}); // ← DOMContentLoaded closing
(function () {
  var DISCOUNT_RATE = 0.20;
  var TARGET_SELECTOR = '.shop-product-price-block';
  var isUpdating = false;

  function parseMoney(value) {
    var matches = String(value || '').match(/\$?\s*([0-9]+(?:\.[0-9]{1,2})?)/g);

    if (!matches || !matches.length) return null;

    var prices = matches
      .map(function (item) {
        return parseFloat(String(item).replace(/[^0-9.]/g, ''));
      })
      .filter(function (price) {
        return Number.isFinite(price) && price > 0;
      });

    if (!prices.length) return null;

    /*
      Bundle card ke andar multiple prices ho sakti hain.
      Usually final bundle price sab se bari value hoti hai:
      29.99 / 72 / 126
    */
    return Math.max.apply(null, prices);
  }

  function formatMoney(price) {
    return '$' + Number(price).toFixed(2);
  }

  function getTargetEl() {
    return document.querySelector(TARGET_SELECTOR);
  }

  function isSubscribeSelected() {
    var toggle = document.getElementById('subscribe-toggle-subscribe_save_NkRYJy');

    if (toggle) {
      return Boolean(toggle.checked);
    }

    var sellingPlanInput = document.querySelector('[name="selling_plan"]');

    return Boolean(sellingPlanInput && sellingPlanInput.value);
  }

  function isSelectedElement(el) {
    if (!el) return false;

    return (
      el.classList.contains('active') ||
      el.classList.contains('selected') ||
      el.classList.contains('is-active') ||
      el.classList.contains('is-selected') ||
      el.classList.contains('checked') ||
      el.getAttribute('aria-checked') === 'true' ||
      el.getAttribute('aria-selected') === 'true' ||
      el.getAttribute('data-selected') === 'true'
    );
  }

  function getSelectedBundleEl() {
    var selectors = [
      '.mqb-option',
      '.mqb-item',
      '.mqb-card',
      '[data-mqb]',
      '[data-quantity]',
      '[data-variant-id]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var items = Array.prototype.slice.call(document.querySelectorAll(selectors[i]));

      var selected = items.find(function (item) {
        return isSelectedElement(item) || item.querySelector('input:checked');
      });

      if (selected) return selected;
    }

    return null;
  }

  function getBundlePriceByText() {
    var selectedEl = getSelectedBundleEl();

    if (selectedEl) {
      var selectedPrice = parseMoney(selectedEl.textContent);

      if (selectedPrice) {
        return selectedPrice;
      }
    }

    /*
      Fallback: visible target price, only useful when OFF.
    */
    var targetEl = getTargetEl();

    if (targetEl && !isSubscribeSelected()) {
      return parseMoney(targetEl.textContent);
    }

    return null;
  }

  function updatePrice() {
    if (isUpdating) return;

    var targetEl = getTargetEl();
    if (!targetEl) return;

    var basePrice = getBundlePriceByText();

    if (!basePrice) {
      console.warn('Bundle base price not found.');
      return;
    }

    var finalPrice = isSubscribeSelected()
      ? basePrice * (1 - DISCOUNT_RATE)
      : basePrice;

    isUpdating = true;
    targetEl.textContent = formatMoney(finalPrice);
    isUpdating = false;

    console.log('Bundle price synced:', {
      selectedBundleText: getSelectedBundleEl() ? getSelectedBundleEl().textContent.trim() : null,
      basePrice: basePrice,
      subscribe: isSubscribeSelected(),
      finalPrice: finalPrice
    });
  }

  function scheduleUpdate() {
    setTimeout(updatePrice, 100);
    setTimeout(updatePrice, 300);
    setTimeout(updatePrice, 700);
    setTimeout(updatePrice, 1200);
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      if (
        event.target.closest('.mqb-option') ||
        event.target.closest('.mqb-item') ||
        event.target.closest('.mqb-card') ||
        event.target.closest('[data-mqb]') ||
        event.target.closest('[data-quantity]') ||
        event.target.closest('[data-variant-id]') ||
        event.target.closest('.subscribe-save-container')
      ) {
        scheduleUpdate();
      }
    });

    document.addEventListener('change', scheduleUpdate);
    document.addEventListener('subscriptionContext:updated', scheduleUpdate);
    document.addEventListener('quantity:changed', scheduleUpdate);
    document.addEventListener('simple-variant-picker:variantChange', scheduleUpdate);

    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(bindEvents, 600);
    });
  } else {
    setTimeout(bindEvents, 600);
  }
})();
